<template>
  <div class="layout-download">
    <div class="corpo">
      <div class="titulo-download negrito">
        {{ titulo }}
      </div>
      <div class="subtitulo-download">
        <slot name="subtitulo" />
      </div>
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    titulo: {
      type: String
    }
  }
};
</script>

<style lang="scss" scoped>
.layout-download {
  padding: 40px 0;
  display: flex;
  flex-flow: wrap column;
  align-content: center;
  .corpo {
    min-height: 370px;
    display: flex;
    flex-flow: wrap column;

    .subtitulo-download {
      line-height: 21px;
      padding-bottom: 48px;
      text-align: center;
    }

    .titulo-download {
      font-size: 20px;
      padding-bottom: 16px;
      text-align: center;
    }
  }
}
</style>
